
define(
	'app/ui/edgecompressioncalculator/edgecompressioncalculator',[
		'jquery',
		'util/fileio',
	],

	function ($, fileIO) {

		var selectors = {
			container: '.js-ecc__form',
			product: '.js-ecc__product',
			slope: '.js-ecc__slope',
			perimeter: '.js-ecc__perimeter',
			rafter: '.js-ecc__rafter',
			heel: '.js-ecc__heel',
			top_plate: '.js-ecc__top-plate',
			roll_panel: '.js-ecc__roll-panel',
			roll_plate_message: '.js-ecc__roll-panel-warning',
			submit: '.js-ecc__submit',
			reset: '.js-ecc__reset',
			data: '.js-ecc__data',
			results: '.js-ecc__results',
			download: '.js-ecc__download',
			productmessage: '.js-ecc__results-product',
			resultsmessage: '.js-ecc__results-message',
			noncompliant: '.js-ecc__results-noncompliant-message',
			errormessage: '.js-error-message',
			errormessagesmall: '.js-error-message__small',
			errormessagelarge: '.js-error-message__large',

			dt: '.js-dt',
			dtm: '.js-dtm',
			dtbar: '.js-dt-bar',
			dtslope: '.js-dt-slope',
			dtHeading: '.js-dt-heading',
			dtIntroduction: '.js-dt-introduction',
			dtNewHeading: '.js-new-heading',
			dtNewIntroduction: '.js-new-introduction',
			dtperim: '.js-dt-perim',
			dtminheight: '.js-dt-min-height',
			dtmaxcomp: '.js-dt-max-comp',
			dtminR: '.js-dt-min-R',
			dttrusschord: '.js-dt-truss-chord',
			dtheelheight: '.js-dt-heel-height',
			dtplateoffset: '.js-dt-plate-offset',
			dtt_offset: '.js-dt-t_offset',
			dtincrollpanel: '.js-dt-include-roll-panel',
			dtuncompinsthick: '.js-dt-uncomp-ins-thick',
			dtuncompinsR: '.js-dt-uncomp-ins-R',
			dtcomparea: '.js-dt-comp-area',
			dtRval: '.js-dt-R-val',
			dtRvalredux: '.js-dt-R-val-redux',

			zoom_button: '.js-zoom-button',
			zoom_icon: '.js-zoom-icon',
			zoom_image: '.js-zoom-image',
			zoom_text: '.js-zoom-text',
		};

		var productValues = {
			'7.0': {
				t0: 275,
				R0: 7,
				CC: 82.71
			},
			'6.0': {
				t0: 235,
				R0: 6,
				CC: 82.01
			},
			'5.0': {
				t0: 225,
				R0: 5,
				CC: 69.55
			},
			'4.5': {
				t0: 210,
				R0: 4.5,
				CC: 63.86
			}
		};

		// input variables
		var t0, R0, CC, Slope, PerimWidth, t_raft, t_raised, x_offset, t1, R1, t_offset, x_compr, x_compr_perimeter, PercMaxCompr, RAverageCompressed, CompressedRValue, CompressionConstant, DataObject;


		var EdgeCompression = {
			init: function () {
				EdgeCompression._initEvents();
			},

			_initEvents: function () {
				$(selectors.product).on('change', EdgeCompression._changeProductSelection);
				$(selectors.submit).on('click', EdgeCompression._calculateResult);
				$(selectors.reset).on('click', EdgeCompression.calculator._resetFields);
				$(selectors.data).on('click', EdgeCompression.calculator._showData);
				$(selectors.zoom_button).on('click', EdgeCompression._zoomimage);
				$(selectors.download).on('click', EdgeCompression.calculator._download);
				$(selectors.roll_panel).on('click', EdgeCompression.calculator._rollPanel);
				$('.js-modal__close').on('click', EdgeCompression._zoomclose);
				$(selectors.slope).on('change', EdgeCompression._Warning);
				$(selectors.perimeter).on('change', EdgeCompression._Warning);
				$(selectors.heel).on('change', EdgeCompression._Warning);
			},

			_changeProductSelection: function () {
				var productSelected = $(selectors.product).val();

				var currentProductValues = productValues[productSelected];

				t0 = currentProductValues.t0;
				R0 = currentProductValues.R0;
				CC = currentProductValues.CC;

				$(selectors.submit).removeAttr('disabled');
			},

			_calculateResult: function (event) {
				event.preventDefault();

				Slope = Number(parseFloat($(selectors.slope).val(), 10));
				PerimWidth = Number(parseFloat($(selectors.perimeter).val(), 10));
				t_raft = Number(parseInt($(selectors.rafter).filter(':checked').val(), 10));
				t_raised = Number(parseFloat($(selectors.heel).val(), 10));
				x_offset = Number(parseInt($(selectors.top_plate).filter(':checked').val(), 10));

				//console.log({
				//	input: {
				//		slope: $(selectors.slope).val(),
				//		perimeter: $(selectors.perimeter).val(),
				//		rafter: $(selectors.rafter).filter(':checked').val(),
				//		heel: $(selectors.heel).val(),
				//		top_plate: $(selectors.top_plate).filter(':checked').val()
				//	},
				//	vars: {
				//		t0,
				//		R0,
				//		CC,
				//		Slope,
				//		PerimWidth,
				//		t_raft,
				//		t_raised,
				//		x_offset
				//	}
				//});

				EdgeCompression.calculator._calculateEdgeCompression(
					Number(t0),
					Number(R0),
					Number(CC),
					Slope,
					PerimWidth,
					t_raft,
					t_raised,
					x_offset
				);
			},

			_zoomimage: function () {
				$(selectors.zoom_button).toggleClass('Zoom');
				$(selectors.zoom_image).toggleClass('zoom');
				$(selectors.zoom_icon).toggleClass('iconf-zoom-in').toggleClass('iconf-zoom-out');
			},

			_zoomclose: function () {
				$(selectors.zoom_button).removeClass('Zoom');
				$(selectors.zoom_image).removeClass('zoom');
				$(selectors.zoom_icon).toggleClass('iconf-zoom-in').toggleClass('iconf-zoom-out');
			},

			_Warning: function () {

				var min = parseFloat($(this).attr('min'));
				var max = parseFloat($(this).attr('max'));
				var curr = parseFloat($(this).val());
				if (curr > max) { $(this).val(max); var changed = true; }
				if (curr < min) { $(this).val(min); var changed = true; }
				if (changed) {
					$warning = $(this).siblings('.warning')
					$warning.text('Only ' + min + ' through ' + max + ' allowed');
					$warning.show()
					$warning.fadeOut(3500);
				}
			},

			// This is external code provided by client
			calculator: {
				_calculateEdgeCompression: function (t0, R0, CC, Slope, PerimWidth, t_raft, t_raised, x_offset) {

					var includeRollPanel = $(selectors.roll_panel).filter(':checked').val() === 'yes';
					CompressionConstant = Number(CC / 100);

					if (includeRollPanel) {
						var CompressedRValueRaw = EdgeCompression.calculator._CompressedR(t0, R0, Slope, PerimWidth, t_raft, t_raised, x_offset, CompressionConstant);
						var CompressedRValueVent = EdgeCompression.calculator._CompressedR(t0, R0, Slope, PerimWidth, t_raft - 50, t_raised, x_offset, CompressionConstant);
						CompressedRValue = 1 / (0.5 / CompressedRValueRaw + 0.5 / CompressedRValueVent);
					} else {
						CompressedRValue = EdgeCompression.calculator._CompressedR(t0, R0, Slope, PerimWidth, t_raft, t_raised, x_offset, CompressionConstant);
					}

					EdgeCompression.calculator._BuildTableData(t0, R0, Slope, PerimWidth, t_raft, t_raised, x_offset, CompressionConstant);

					var isNonCompliantA = EdgeCompression.calculator._x_compr_fktn(t0, EdgeCompression.calculator._t1_fktn(t0, Slope, t_raft, t_raised, 45), Slope) > PerimWidth + 500; // == invalid
					var isNonCompliantB = EdgeCompression.calculator._x_compr_fktn(t0, EdgeCompression.calculator._t1_fktn(t0, Slope, t_raft - 50, t_raised, 45), Slope) > PerimWidth + 500; // == invalid
					var isNonCompliant = isNonCompliantA || isNonCompliantB;

					EdgeCompression.calculator._getResultValue(CompressedRValue, isNonCompliant);
				},

				_CompressedR: function (t0, R0, Slope, PerimWidth, t_raft, t_raised, x_offset, CompressionConstant) {

					t1 = EdgeCompression.calculator._t1_fktn(t0, Slope, t_raft, t_raised, x_offset);

					x_compr = EdgeCompression.calculator._x_compr_fktn(t0, t1, Slope);
					x_compr_perimeter = Math.min(PerimWidth, x_compr);
					PercMaxCompr = (t0 - t1) / t0;
					R1 = R0 - (PercMaxCompr * CompressionConstant * R0);
					R1 = Math.abs(R1);

					var DeltaRovDeltax = (x_compr > 0) ? (R0 - R1) / x_compr : 0;
					RAverageCompressed = (DeltaRovDeltax > 0) ? -x_compr_perimeter / ((Math.log(R1) - Math.log(R1 + DeltaRovDeltax * x_compr_perimeter)) / DeltaRovDeltax) : R0;
					var CompressedR = PerimWidth / (x_compr_perimeter / RAverageCompressed + Math.max(PerimWidth - x_compr, 0) / R0);

					return CompressedR;
				},

				_BuildTableData: function (t0, R0, Slope, PerimWidth, t_raft, t_raised, x_offset, CompressionConstant) {

					t1 = EdgeCompression.calculator._t1_fktn(t0, Slope, t_raft, t_raised, x_offset);

					x_compr = EdgeCompression.calculator._x_compr_fktn(t0, t1, Slope);
					x_compr_perimeter = Math.min(PerimWidth, x_compr);
					PercMaxCompr = (t0 - t1) / t0;
					R1 = R0 - (PercMaxCompr * CompressionConstant * R0);
					R1 = Math.abs(R1);

					var DeltaRovDeltax = (x_compr > 0) ? (R0 - R1) / x_compr : 0;
					RAverageCompressed = (DeltaRovDeltax > 0) ? -x_compr_perimeter / ((Math.log(R1) - Math.log(R1 + DeltaRovDeltax * x_compr_perimeter)) / DeltaRovDeltax) : R0;
					var CompressedR = PerimWidth / (x_compr_perimeter / RAverageCompressed + Math.max(PerimWidth - x_compr, 0) / R0);

					EdgeCompression.calculator._changeData();

					return CompressedR;
				},

				_t1_fktn: function (t0, Slope, t_raft, t_raised, x_offset) { //t1: compressed thickness at thinnest point

					var SlopeRad = Slope / 180. * Math.PI;
					var t_raft_sloped = t_raft / Math.cos(SlopeRad);
					t_offset = x_offset * Math.tan(SlopeRad);
					t1 = Math.min(t_raft_sloped + t_offset + t_raised, t0);

					return t1;
				},

				_x_compr_fktn: function (t0, t1, Slope) {

					var SlopeRad = Slope / 180. * Math.PI;
					x_compr = (t0 - t1) / Math.tan(SlopeRad);

					return x_compr;
				},

				_rollPanel: function () {

					var includeRollPanel = $(selectors.roll_panel).filter(':checked').val() === 'no';

					if (includeRollPanel) {
						$(selectors.roll_plate_message).show();
					} else {
						$(selectors.roll_plate_message).hide();
					}

				},

				_getResultValue: function (CompressedRValue, isNonCompliant) {

					CompressedRValue = Math.round(CompressedRValue * 100) / 100;

					var productSelected = $(selectors.product).find('option:selected').text();

					$(selectors.results).show();

					$(selectors.productmessage).text(productSelected);
					$(selectors.resultsmessage).text(CompressedRValue);

					if (isNonCompliant === true) {
						$(selectors.noncompliant).show();
						$(selectors.errormessage).show();
						$(selectors.noncompliant).addClass('Error');
						$(selectors.resultsmessage).addClass('Error');

						if (CompressedRValue > '3.5') {
							$(selectors.errormessagesmall).hide();
							$(selectors.errormessagelarge).show();
						} else {
							$(selectors.errormessagesmall).show();
							$(selectors.errormessagelarge).hide();
						}

					} else {
						$(selectors.noncompliant).hide();
						$(selectors.errormessage).hide();
						$(selectors.noncompliant).removeClass('Error');
						$(selectors.resultsmessage).removeClass('Error');
					}

					DataObject.IsCompliant = isNonCompliant === false;

					//console.log({
					//	_: '_getResultValue',
					//	isNonCompliant,
					//	DataObject
					//});

					return CompressedRValue;
				},

				_resetFields: function (CompressedRValue, isNonCompliant) {

					$(selectors.container).trigger("reset");

					$(selectors.results).hide();
					$(selectors.dt).hide();
					$(selectors.roll_plate_message).hide();

					$(selectors.submit).attr("disabled", true);

					document.getElementById("ViewData").innerHTML = "View all data";
				},

				_changeData: function () {
					var dtincrollpanel = $(selectors.roll_panel).filter(':checked').val();
					var productSelected = $(selectors.product).find('option:selected').text();

					PercMaxCompr = (t0 - t1) / t0;
					R1 = R0 - (PercMaxCompr * CompressionConstant * R0);

					PercMaxCompr = Math.round(((PercMaxCompr * 100) / 100) * 100);

					t1 = Math.round(t1 * 100) / 100;

					R1 = Math.round(R1 * 100) / 100;

					$(selectors.dtbar).text(productSelected);

					$(selectors.dtslope).text(Slope);
					$(selectors.dtperim).text(PerimWidth);
					$(selectors.dtminheight).text(t1);
					$(selectors.dtmaxcomp).text(PercMaxCompr + '%');

					$(selectors.dtminR).text(R1);
					$(selectors.dttrusschord).text(t_raft);
					$(selectors.dtplateoffset).text(x_offset);
					$(selectors.dtt_offset).text(t_raised);

					$(selectors.dtincrollpanel).text(dtincrollpanel);
					$(selectors.dtuncompinsthick).text(t0);
					$(selectors.dtuncompinsR).text(R0);
					$(selectors.dtRvalredux).text(CC + '%');

					CompressedRValue = Math.round(CompressedRValue * 100) / 100;

					if (dtincrollpanel === "yes") {
						var dtbool = true;
					} else {
						var dtbool = false;
					}

					var $complianceMessage = $(selectors.noncompliant);

					DataObject = {
						CompressedRValue: CompressedRValue,
						productSelected: productSelected,
						Slope: Slope,
						PerimWidth: PerimWidth,
						t1: t1,
						PercMaxCompr: PercMaxCompr,
						R1: R1,
						t_raft: t_raft,
						x_offset: x_offset,
						t_raised: t_raised,
						incrollpanel: dtbool,
						t0: t0,
						R0: R0,
						CC: CC,
						IsCompliant: $complianceMessage.is('.Error') === false
					};

					//console.log({
					//	_: '_changeData',
					//	$complianceMessage,
					//	DataObject
					//});
				},

				_showData: function () {

					$(selectors.dt).toggle();

					var x = document.getElementById("ViewData");
					if (x.innerHTML === "View all data") {
						x.innerHTML = "Hide all data";
					} else {
						x.innerHTML = "View all data";
					}
				},

				_download: function () {

					//console.log({
					//	_: '_download',
					//	DataObject
					//});

					var action = $(selectors.download).data('action');
					var filename = "Edge Compression Results.PDF";
					var request;

					request = new XMLHttpRequest();
					request.open('POST', action, true);
					request.responseType = "arraybuffer";

					request.onload = EdgeCompression.calculator._handleDownloadResponse(request, filename);

					var data = new FormData();
					var keys = Object.keys(DataObject);
					for (var i = 0; i < keys.length; i++) {
						data.append(keys[i], DataObject[keys[i]]);
					}
					request.send(data);
				},

				_handleDownloadResponse: function (request, filename) {
					return function (event) {

						if (request.status === 200) {
							EdgeCompression.calculator._downloadSuccess(filename, request);
						} else {
							console.log("Nope");
						}
					};
				},

				_downloadSuccess: function (filename, request) {
					fileIO.save.data(request.response, filename, 'application/pdf');
				},
			}
		};

		return {
			init: EdgeCompression.init
		};
	}
);
